<template>
  <div>
    <h1>test</h1>
    <v-container grid-list-md>
      <v-layout>
        <v-flex xs4>
          <v-text-field label="Solo" solo height="50"></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field label="Solo"></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field label="Solo" solo flat></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field label="Solo" solo-inverted></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
